export default "__VITE_ASSET__DD6N92cQ__"